import { Component, Input } from '@angular/core';
import { customCard } from 'src/app/shared/model/customCard';

@Component({
    selector: 'app-resources-page',
    templateUrl: './resources-page.component.html',
    styleUrl: './resources-page.component.scss',
    standalone: false
})
export class ResourcesPageComponent {
  @Input() cardslist!: customCard[];

  cardsList: customCard[] = [
    {
      icon: '/assets/icons/blue-logo-bg.svg',
      title: 'Greentripper Climate Partner',
      link: 'home/ressources/climate-partner',
    },
    {
      icon: '/assets/icons/blue-leaf-bg.svg',
      title: 'Supported Climate Projects',
      link: 'home/ressources/climate-projects',
    },
    {
      icon: '/assets/icons/blue-handshake-bg.svg',
      title: 'Your Climate Initiatives',
      link: 'home/ressources/climate-initiatives',
    },
  ];
}
